import {
  FETCH_KITCHEN_ORDERS_REQUEST,
  FETCH_KITCHEN_ORDERS_SUCCESS,
  FETCH_KITCHEN_ORDERS_FAILURE,
} from "./kitchenActionTypes";


// Fetch Kitchen Orders
export const fetchKitchenOrdersRequest = () => ({
  type: FETCH_KITCHEN_ORDERS_REQUEST,
});

export const fetchKitchenOrdersSuccess = (orders) => ({
  type: FETCH_KITCHEN_ORDERS_SUCCESS,
  payload: orders,
});

export const fetchKitchenOrdersFailure = (error) => ({
  type: FETCH_KITCHEN_ORDERS_FAILURE,
  payload: error,
});